/**
 * 路由系统 — 页面切换管理
 */

import { renderTimeline } from '../components/Timeline.js';
import { renderDetailView } from '../components/DetailView.js';

let currentPage = 'home';
let currentUmbrellaId = null;
const app = document.getElementById('app');

/**
 * 初始化路由
 */
export function initRouter() {
  // 创建页面容器
  app.innerHTML = `
    <div id="page-home" class="page active"></div>
    <div id="page-detail" class="page"></div>
  `;

  // 渲染首页
  renderTimeline();

  // 处理浏览器历史
  window.addEventListener('popstate', handlePopState);
}

/**
 * 导航到首页
 */
export function navigateToHome() {
  const homePage = document.getElementById('page-home');
  const detailPage = document.getElementById('page-detail');

  if (detailPage) detailPage.classList.remove('active');
  if (homePage) homePage.classList.add('active');

  currentPage = 'home';
  currentUmbrellaId = null;

  window.scrollTo(0, 0);
}

/**
 * 导航到详情页
 */
export function navigateToDetail(umbrellaId) {
  const homePage = document.getElementById('page-home');
  const detailPage = document.getElementById('page-detail');

  currentUmbrellaId = umbrellaId;

  // 先渲染详情页内容
  renderDetailView(umbrellaId);

  // 切换页面显示
  if (homePage) homePage.classList.remove('active');
  if (detailPage) {
    detailPage.classList.add('active');
  }

  currentPage = 'detail';

  // 更新历史记录
  history.pushState({ page: 'detail', id: umbrellaId }, '', `#${umbrellaId}`);
}

/**
 * 处理浏览器返回
 */
function handlePopState(e) {
  const state = e.state;
  if (!state || state.page === 'home') {
    navigateToHome();
  } else if (state.page === 'detail' && state.id) {
    navigateToDetail(state.id);
  }
}

/**
 * 获取当前页面
 */
export function getCurrentPage() {
  return currentPage;
}

/**
 * 获取当前伞ID
 */
export function getCurrentUmbrellaId() {
  return currentUmbrellaId;
}
